import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface SkyPanelProps {
    children: ReactNode
    className?: string
    innerClassName?: string
    mirror?: boolean
    preload?: boolean
}

/*
 * Rounded panel painted with the soft sky. Its content sits on z-20 so the
 * decorative foliage (z-10, multiply blend) can overlap the painting but
 * stays behind cards and the product window.
 */
export const SkyPanel: FC<SkyPanelProps> = ({
    children,
    className,
    innerClassName,
    mirror = false,
    preload = false
}): ReactNode => {
    return (
        <div className={cn('relative overflow-hidden rounded-[28px] bg-cloud', className)}>
            <Image
                src='/images/sky.jpg'
                alt=''
                fill
                sizes='100vw'
                preload={preload}
                className={cn('sky-drift object-cover', mirror && '[transform:scaleX(-1)]')}
            />

            <div aria-hidden='true' className='absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-white/30' />

            <div className={cn('relative z-20', innerClassName)}>
                {children}
            </div>
        </div>
    )
}
